import { Component, OnInit, Input } from '@angular/core';
import { CommonConstant } from '../../../app.constants';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'pdf-viewer-header',
  templateUrl: './pdf-viewer-header.component.html',
  styleUrls: ['./pdf-viewer-header.component.scss']
})
export class PdfViewerHeaderComponent implements OnInit {
  @Input() period: number;
  @Input() currentDate: Date;
  @Input() previousDate: Date;
  constructor(private userService: UserService) { }

  ngOnInit() {
    if (!this.previousDate && !this.currentDate) {
      this.currentDate = new Date();
      this.previousDate = new Date();
      const period_time = this.period ? this.period : CommonConstant.PERIOD_30_DAYS;
      this.previousDate.setDate(this.previousDate.getDate() - period_time);
    }
  }

  get logoImage() {
    return this.userService.logoImage;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-header/pdf-viewer-header.component.ts